module.exports = __webpack_public_path__ + "img/linux.aae89f56.svg";